import React, { useState } from 'react';
import { Button, Modal, Collapse, Tag, Typography, Space, Descriptions, Card, Tooltip } from "antd";
import { CopyOutlined } from '@ant-design/icons';

const DataViewer = ({ data, title }) => {
  const [isCopied, setIsCopied] = useState(false);

  if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
    return null;
  }

  const handleCopy = () => {
    const textToCopy = typeof data === 'object' ? JSON.stringify(data, null, 2) : data;

    navigator.clipboard.writeText(textToCopy).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2500);
    });
  };

  let content = data;
  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      content = JSON.stringify(parsed, null, 2);
    } catch (error) {
    }
  }

  return (
    <div style={{ marginTop: 16 }}>
      <Card
        title={title}
        size="small"
        extra={
          <Tooltip title={isCopied ? 'Copiado!' : `Copiar`}>
            <Button icon={<CopyOutlined />} type="text" onClick={handleCopy} >
              Copiar
            </Button>
          </Tooltip>
        }
      >
        {typeof data === 'object' ? (
          <Descriptions bordered column={1} size="small">
            {Object.entries(data).map(([key, value]) => (
              <Descriptions.Item key={key} label={key}>
                {String(value)}
              </Descriptions.Item>
            ))}
          </Descriptions>
        ) : (
          <Typography.Text style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
            {content}
          </Typography.Text>
        )}
      </Card>
    </div>
  );
};


export const TriggerResponseModal = ({ isOpen, setIsOpen, actions = [] }) => {

  const getStatusColor = (statusCode) => {
    if (statusCode >= 400) return 'red';
    if (statusCode >= 200 && statusCode < 300) return 'green';
    return 'blue';
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const validActions = actions.filter(action => action && Object.keys(action).length > 0);

  return (
    <Modal
      title="Respostas dos Gatilhos (Triggers)"
      open={isOpen}
      onCancel={handleClose}
      width={800}
      footer={[
        <Button key="close" type="primary" onClick={handleClose}>
          Fechar
        </Button>,
      ]}
    >
      {validActions.length > 0 ? (
        <Collapse accordion>
          {validActions.map((action, index) => (
            <Collapse.Panel
              key={index}
              header={
                <Space>
                  <Tag color={getStatusColor(action.status_code)}>
                    {action.status_code || 'N/A'}
                  </Tag>
                  <Typography.Text>{action.url}</Typography.Text>
                </Space>
              }
            >
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="URL Completa">{action.url}</Descriptions.Item>
                <Descriptions.Item label="Status Code">{action.status_code}</Descriptions.Item>
              </Descriptions>

              <DataViewer data={action.request_header} title="Cabeçalhos da Requisição (Headers)" />
              <DataViewer data={action.request_body} title="Corpo da Requisição (Request Body)" />
              <DataViewer data={action.response_body} title="Corpo da Resposta (Response Body)" />

            </Collapse.Panel>
          ))}
        </Collapse>
      ) : (
        <Typography.Text>Nenhuma ação de trigger foi executada nesta resposta.</Typography.Text>
      )}
    </Modal>
  );
};
